__webpack_require__.p = "/react-form-pokeapi/";